import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { MyDraggable as Draggable } from '../../components/Core';
import HoverBar from '../../components/HoverBar';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col } from 'reactstrap';
import state from '../../state';
import { inlineElements, generateStyle, setOverLay, l } from '../../functions';
import Icon from '../../components/Icons';
import isEqual from 'lodash/isEqual';

const mapStateToProps = (state) => {
  return {
    fetchedProducts: state.rootReducer.fetchedProducts || {},
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class FlyoutCartSummary extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProp, nextState) {
    if (!isEqual(this.props?.payload, nextProp?.payload) || !isEqual(this.props?.settings, nextProp?.settings)) {
      return true;
    }

    return false;
  }

  _initButton = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;
    const appearanceSettings = this.props.settings;

    const cssSettings = generateStyle(payload, 'container');
    const cssSettingsText = generateStyle(payload, 'text', 'body');
    console.log(cssSettingsText);
    let cssButton = {
      backgroundColor: appearanceSettings['active_button_color']?.bgColor || null,
      color: appearanceSettings['active_button_text_color'].color || null,
    };

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className='fullcol'>
            <div className='flyoutcart-summary' style={cssSettingsText}>
              <div className='products'>
                {Object.keys(this.props.fetchedProducts)
                  .slice(0, 3)
                  .map((id_product, key) => {
                    const product = this.props.fetchedProducts[id_product];

                    return (
                      <div key={key} className='product'>
                        <div className='cart-images'>
                          <img src={product.image} />
                        </div>
                        <div className='cart-info'>
                          <div className='product-name'>
                            <span className='quantity-formatted'>
                              <span className='quantity'>{key + 1}</span>
                            </span>
                            <span className='cart_block_product_name'>{product.name}</span>
                          </div>

                          <div className='quantity-outer-wrapper'>
                            <div className='button'>
                              <button className='minus_quant'>-</button>
                            </div>
                            <div className='quantity_sec'>
                              <span>2</span>
                            </div>
                            <div className='button'>
                              <button className='plus_quant'>+</button>
                            </div>
                          </div>
                          <span className='price'>
                            <ul>
                              <li>{product.price['reduced-price']}</li>
                            </ul>
                          </span>
                        </div>
                        <span className='remove_link'>
                          <span className='ajax_cart_block_remove_link' style={cssButton}>
                            {l('Remove')}
                          </span>
                        </span>
                      </div>
                    );
                  })}
              </div>

              <div className='cart-prices'>
                <div className='cart-prices-line'>
                  <span>Total</span>
                  <span className='price cart_block_total ajax_block_cart_total'>--</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const { dropzoneID, parentID, showBasicContent, showPreview, id, dropzoneProps, payload, options, ...rest } =
      this.props;

    if (showBasicContent) {
      const elements = state.getStorableState();
      let inDrop = false;

      if (Array.isArray(elements) && elements.length > 0) {
        const inlinedElements = inlineElements(elements);
        if (Array.isArray(inlinedElements) && inlinedElements.length > 0) {
          inlinedElements.forEach((element) => {
            if (element.type === this.props.type) inDrop = true;
          });
        } else inDrop = false;
      } else inDrop = false;

      return (
        <Draggable {...this.props} side={true}>
          <span className='dragger'>
            {(Array.isArray(rest.icon) && <FontAwesomeIcon icon={rest.icon} />) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
            {(inDrop && <span className='added'>{l('Added')}</span>) || (
              <span className='required'>{l('Required')}</span>
            )}
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initButton()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initButton()}
      </Draggable>
    );
  }
}

FlyoutCartSummary.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(FlyoutCartSummary);
